import React, { FC } from 'react';

import { Stack, StackProps, Typography } from '@mui/material';

interface IProps extends StackProps {
  onClick?: VoidFunction;
  index: number;
  isActive?: boolean;
  children: React.ReactElement;
}

const ClauseCard: FC<IProps> = ({
  index,
  isActive = false,
  children,
  ...rest
}) => {
  return (
    <Stack
      sx={{
        background: isActive ? '#FFFAFA' : '#FFF7FA',
        padding: '8px 16px',
        margin: '8px 0',
        borderRadius: '12px',
        border: isActive ? '1px solid #88305F' : 'none',
        cursor: 'pointer',
      }}
      gap="8px"
      {...rest}
    >
      <Typography fontWeight="600" fontSize="14px">{`#${
        index + 1
      }`}</Typography>
      {children}
    </Stack>
  );
};

export default ClauseCard;
